import script from "./LayoutPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutPopover.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__